import { createPortal } from "react-dom";

const Portal = ({ children, target }) => createPortal(children, target);

export default Portal;
